jQuery(function ($) {
    $('.ctr-button').click(function(e){
        $(this).removeClass('gtm-strongintent');
        $(this).find('span').removeClass('gtm-strongintent');
        if (window.__ctm) { window.__ctm.main.runNow(); }
        let ctmHref = $('.organiser-telnum').closest('a[href^="tel"]').first().attr('href') || 'tel:+4620828282';
        window.location.href = ctmHref;
    });

    $('.ctr-organiser__button').click(function(e){
        $(this).removeClass('gtm-strongintent');

        if ($(window).width() < 768) {
            if (window.__ctm) { window.__ctm.main.runNow(); }
            let ctmHref = $('.organiser-telnum').closest('a[href^="tel"]').attr('href') || 'tel:+4620828282';
            window.location.href = ctmHref;
        } else {
            $(this).closest('.ctr-organiser__button_wrp').toggleClass('open');
            let span = $('.ctr-organiser__ring');
            let ctmSpan = $('.organiser-telnum').first();
            let ctmNumber = ctmSpan.text() || '020-82 82 82';
            let ctmHref = ctmSpan.closest('a[href^="tel"]').attr('href') || 'tel:+4620828282';
            span.html('<a class="ctr-organiser__phone" href="' + ctmHref + '">' + ctmNumber + '</a>');
        }
    });

    $('.ctr-textlink').click(function(e){
        let span = $(this).find('span');
        $(this).find('span').removeClass('gtm-strongintent');
        let ctmNumber = $('.organiser-telnum').first().text() || '020-82 82 82';
        let ctmHref = $('.organiser-telnum').closest('a[href^="tel"]').first().attr('href') || 'tel:+4620828282';
        span.html('<a href="' + ctmHref + '">' + ctmNumber + '</a>');
        if (window.__ctm) { window.__ctm.main.runNow(); }
        e.stopImmediatePropagation();
    });

    $('.ctr-kyrklig-btn').click(function(e){
        let span = $(this).find('span');
        $(this).removeClass('gtm-strongintent');
        $(this).find('span').removeClass('gtm-strongintent');
        let ctmNumber = $('.organiser-telnum').first().text() || '020-82 82 82';
        let ctmHref = $('.organiser-telnum').closest('a[href^="tel"]').first().attr('href') || 'tel:+4620828282';
        span.html('<a href="' + ctmHref + '"><button type="button" class="btn btn-blue" title="Kontakta oss för att komma igång med er planering">' + ctmNumber + '</button></a>');
        if (window.__ctm) { window.__ctm.main.runNow(); }
    });

    $('.ctr-ringoss').click(function(e){
        let span = $(this).find('span');
        $(this).removeClass('gtm-strongintent');
        $(this).find('span').removeClass('gtm-strongintent');
        let ctmNumber = $('.organiser-telnum').first().text() || '020-82 82 82';
        let ctmHref = $('.organiser-telnum').closest('a[href^="tel"]').first().attr('href') || 'tel:+4620828282';
        span.html('<a href="' + ctmHref + '">' + ctmNumber + '</a>');
        if (window.__ctm) { window.__ctm.main.runNow(); }
    });
});
